import VergeScreen from './VergeScreen';

export default VergeScreen;